import React, { useCallback } from 'react'

import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'

import { indexes } from '@mab-common/utils'

import type { ProfileImageProps } from '~/components/atoms/ProfileImage/ProfileImage'
import {
  SearchAnalystEventNames,
  SearchAnalystMethods,
} from '~/services/elastic/analyst'

import ArtistProfileList from '../ArtistProfileList/ArtistProfileList'

import styles from './ArtistsIndexList.module.css'
import RecordTypes = indexes.RecordTypes

export interface TArtistPopular extends ProfileImageProps {
  featured?: boolean
}

export interface ArtistsIndexListProps {
  defaultArtistList: TArtistPopular[]
}
export default function ArtistsIndexList({
  defaultArtistList,
}: ArtistsIndexListProps) {
  const router = useRouter()
  const t = useTranslations('common')

  // override when search is active
  const artistList = defaultArtistList
  // define the title variation
  const title = t('popularArtists')

  const renderDesktopView = useCallback(() => {
    const featured = [...artistList].filter(x => x.featured)
    // const popular = [...artistList].filter(x => !x.featured)
    const popular: any[] = []

    // merge both popular and featured into one array
    const allArtists = [...featured, ...popular]

    return (
      <>
        <ArtistProfileList
          title={title}
          artists={allArtists ? allArtists : []}
          totalArtists={allArtists.length}
          allBtnHandler={() => router.push('/artworks')}
          searchInsightsEvent={{
            method: SearchAnalystMethods.clickedFilters,
            name: SearchAnalystEventNames.homeArtistClicked,
          }}
          recordType={RecordTypes.ARTIST}
          showViewAll={true}
          hideViewAll={true}
          alwaysShowViewAll={true}
          viewAllLabel={t('allArtworks')}
        />
      </>
    )
  }, [artistList, t])

  return <div className={styles.base}>{renderDesktopView()}</div>
}
